import React from "react";

export const LazyCreateAccountPage = React.lazy(
  () => import("modules/investorRole/pages/AccountsPage/CreateAccountPage"),
);
